import { CSS, StyleProps } from "../../styles"

export const title = (props: StyleProps): CSS => ({
  marginBottom: 0,
  lineHeight: props.theme.typography.body.lineHeight,
})
export const marginBottom = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(6),
})
export const subtitle = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(6),
})

export const cardOuterContainer = (): CSS => ({
  display: `flex`,
  flexDirection: `column`,
  alignItems: `space-between`,
  maxWidth: `100%`,
  height: `100%`,
})
export const cardContainer = (): CSS => ({
  display: `flex`,
  flexDirection: `column`,
  alignItems: `space-between`,
  maxWidth: `690px`,
  height: `100%`,
})
export const chartAndLegendWrap = (props: StyleProps): CSS => ({
  flexDirection: `column`,
  [props.theme.breakPoints.xxxl.up]: {
    flexDirection: `row`,
  },
})
export const legendContainer = (props: StyleProps): CSS => ({
  flexWrap: `wrap`,
  alignSelf: `center`,
  justifyContent: `flex-start`,
  marginTop: 0,
  [props.theme.breakPoints.lg.up]: {
    marginTop: props.theme.spacing(8),
  },
  [props.theme.breakPoints.xl.up]: {
    marginTop: 0,
  },
  [props.theme.breakPoints.xxl.up]: {
    marginTop: props.theme.spacing(8),
    justifyContent: `center`,
  },
  [props.theme.breakPoints.xxxl.up]: {
    justifyContent: `flex-start`,
    marginTop: 0,
    marginLeft: props.theme.spacing(9),
  },
})
export const chartContainer = (props: StyleProps): CSS => ({
  display: `none`,
  [props.theme.breakPoints.lg.up]: {
    display: `block`,
  },
  [props.theme.breakPoints.xl.up]: {
    display: `none`,
  },
  [props.theme.breakPoints.xxl.up]: {
    display: `block`,
  },
})
